import React, { useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useQuery } from "@redux-requests/react";
import { Formik } from "formik";
import { Loader } from "../../components";
import { FileUploaderField, SubmitButton, TextField } from "../../components/formik";
import { types } from "../../ducks";
import { getSessionPresentation, updateSessionPresentation } from "../../ducks/actions";
import { useActionRequest } from "../../hooks";

const EditSessionPresentationDialog = ({ id, onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(getSessionPresentation({ id }));
    }
  }, [dispatch, id]);

  const {
    data: { session_presentation: sessionPresentation },
    loading: sessionPresentationLoading
  } = useQuery({ type: types.GET_SESSION_PRESENTATION, defaultData: { session_presentation: {} } });

  const updateSessionPresentationRequest = useActionRequest({
    action: updateSessionPresentation
  });

  const onUpdateSessionPresentation = async value => {
    updateSessionPresentationRequest({
      id,
      sessionPresentation: value
    });
    onClose();
  };

  const initialValues = {
    title: "",
    subtitle: "",
    body: "",
    file: null,
    ...sessionPresentation
  };

  return (
    <Loader loading={sessionPresentationLoading}>
      <Formik onSubmit={onUpdateSessionPresentation} initialValues={initialValues}>
        <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
          <DialogContent>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="h5" noWrap>
                {intl.formatMessage({
                  id: "MyPresentations.EditSessionPresentationDialog.UploadSessionPresentation",
                  defaultMessage: "Upload Session Presentation"
                })}
              </Typography>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
            <FileUploaderField
              name="file"
              accept="application/pdf, application/vnd.openxmlformats-officedocument.presentationml.presentation"
              label={intl.formatMessage({
                id: "MyPresentations.EditSessionPresentationDialog.PresentationFile",
                defaultMessage: "Presentation file"
              })}
              buttonLabel={intl.formatMessage({
                id: "MyPresentations.EditSessionPresentationDialog.Upload",
                defaultMessage: "Upload"
              })}
            />
            <TextField
              name="title"
              variant="outlined"
              label={intl.formatMessage({
                id: "MyPresentations.EditSessionPresentationDialog.Title",
                defaultMessage: "Title"
              })}
              disabled
              fullWidth
            />
            <TextField
              name="subtitle"
              variant="outlined"
              label={intl.formatMessage({
                id: "MyPresentations.EditSessionPresentationDialog.SubTitle",
                defaultMessage: "Sub title"
              })}
              disabled
              fullWidth
            />
            <TextField
              name="body"
              variant="outlined"
              label={intl.formatMessage({
                id: "MyPresentations.EditSessionPresentationDialog.Body",
                defaultMessage: "Body"
              })}
              fullWidth
              multiline
              minRows={3}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>
              {intl.formatMessage({
                id: "MyPresentations.EditSessionPresentationDialog.Close",
                defaultMessage: "Close"
              })}
            </Button>
            <SubmitButton variant="contained" color="primary" size="small">
              {intl.formatMessage({
                id: "MyPresentations.EditSessionPresentationDialog.Save",
                defaultMessage: "Save"
              })}
            </SubmitButton>
          </DialogActions>
        </Dialog>
      </Formik>
    </Loader>
  );
};

export default EditSessionPresentationDialog;
